import { Currency } from '../../shared/lib/currency'
import { DeliveryMethods } from './cart'

export enum ProductFields {
  ID = 'id',
  AMOUNT = 'amount',
  PERSONALISE_TO_NAME = 'personaliseToName',
  PERSONALISE_FROM_NAME = 'personaliseFromName',
  PERSONALISE_MESSAGE = 'personaliseMessage',
  DELIVERY_METHOD = 'deliveryMethod',
  DELIVERY_METHOD_EMAIL = 'deliveryMethodEmail',
  IMMEDIATE_DELIVERY_DATE = 'immediateDeliveryDate',
  DELIVERY_DATE = 'deliveryDate',
  QUANTITY = 'quantity',
}

export interface IProductValues {
  [ProductFields.ID]?: string
  [ProductFields.AMOUNT]: Currency
  [ProductFields.PERSONALISE_TO_NAME]: string
  [ProductFields.PERSONALISE_FROM_NAME]: string
  [ProductFields.PERSONALISE_MESSAGE]: string
  [ProductFields.DELIVERY_METHOD]: DeliveryMethods
  [ProductFields.DELIVERY_METHOD_EMAIL]: string
  [ProductFields.IMMEDIATE_DELIVERY_DATE]: string
  [ProductFields.DELIVERY_DATE]: string
}

export interface IMKPProductValues {
  [ProductFields.QUANTITY]: number | string
  [key: string]: string | number
}
